<template>
  <body class="choosingWecobi-body">
    <div class="title">By Choosing Wecobi,</div>
    <div class="text">
      brands can build a marketing strategy that is more effective, authentic,
      and aligned with customer values, all while reducing dependency on
      traditional social media platforms.
    </div>
  </body>
</template>

<script>
export default {
  name: "ChoosingWecobi",
  components: {},
};
</script>

<style scoped>
.choosingWecobi-body {
  width: 100%;
  height: 280px;
  border-radius: 20px;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 80px 120px;
  box-sizing: border-box;
}

.choosingWecobi-body::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to left, #f98140 28%, #eb4dbf 72%);
  opacity: 0.7;
  z-index: -1;
}
.title {
  font-size: 25px;
  font-weight: 700;
  line-height: 1.7;
  color: #000000;
}
.text {
  font-size: 18px;
  font-weight: 400;
  line-height: 1.7;
  color: #000000;
  max-width: 940px;
}

@media (max-width: 1280px) {
  .text {
    max-width: 683px;
  }
}
@media (max-width: 1024px) {
  .choosingWecobi-body {
    padding: 60px 120px;
  }
  .text {
    font-size: 16px;
    max-width: 427px;
  }
}
@media (max-width: 750px) {
  .choosingWecobi-body {
    padding: 60px;
    height: fit-content;
  }
  .text {
    width: 100%;
  }
}
</style>
